export enum ACTIONS {
  LOAD_DATA = 'LOAD_DATA',
  LOAD_INPUTS = 'LOAD_INPUTS',
  MOVE = 'MOVE',
  DELETE = 'DELETE',
  REORDER = 'REORDER',
  SET_DATA = 'SET_DATA',
  TOGGLE_REQUIRED = 'TOGGLE_REQUIRED',
}
